<template>
    <div class="duplicate-day">
        <h2 class="title">{{ $t('repetir-contrato') }}</h2>

        <div class="days-of-week">
            <!-- SEMANAL -->
            <f-switch
                v-for="n in value.periodo"
                :key="n"
                :text="`${$t(getDiaString(n - 1))} (${$moment()
                    .day(n - 1)
                    .format('L')})`"
                :checked="temp[n - 1]"
                @change="updateCheck(n - 1, $event)"
            />
            <fSwitch :text="$t('todos-os-dias')" :checked="todos" @change="selectAll" />
        </div>
        <div class="form-buttons">
            <button class="cancel-btn" type="button" @click="close()">
                {{ $t('cancelar') }}
            </button>
            <button class="save-btn" type="button" @click="duplicateTo(temp)">
                {{ $t('salvar-horario') }}
            </button>
        </div>
    </div>
</template>

<script>
import fSwitch from '@/components/shared/form/Switch.vue';

export default {
    props: {
        value: {
            default: {},
        },
    },
    data() {
        return {
            grandparent: this.$parent.$parent,
            promotores: [],
            temp: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
                10: false,
                11: false,
                12: false,
                13: false,
            },
            todos: false,
        };
    },
    created() {
        this.value.days.forEach((n) => {
            this.temp[n] = true;
        });
    },
    components: {
        fSwitch,
    },
    methods: {
        updateCheck(n, e) {
            this.temp[n] = e;
            this.checkTodos();
        },
        selectAll(e) {
            for (var i = 0; i < this.value.periodo; i++) {
                this.temp[i] = e;
            }

            this.todos = e;
        },
        checkTodos() {
            let all = true;

            for (var d in this.temp) {
                if (!this.temp[d]) {
                    all = false;
                }
            }

            this.todos = all;
        },
        close() {
            this.$parent.closeModal();
        },
        duplicateTo(value) {
            let r = {
                periodo: this.value.periodo,
                days: [],
            };

            for (var d in this.temp) {
                if (this.temp[d]) {
                    r.days.push(d);
                }
            }

            this.grandparent.$emit('duplicate-data', r);
            this.$parent.closeModal();
        },
        getDiaString(n) {
            let d = n % 7;

            switch (d) {
                case 0:
                    return 'domingo';
                case 1:
                    return 'segunda';
                case 2:
                    return 'terca';
                case 3:
                    return 'quarta';
                case 4:
                    return 'quinta';
                case 5:
                    return 'sexta';
                case 6:
                    return 'sabado';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.duplicate-day {
    .days-of-week {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 35px 20px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        border-radius: 10px;

        > .obrigatorio {
            width: 30%;
            margin-bottom: 10px;
        }
    }
    .form-buttons {
        position: absolute;
        top: 10px;
        right: 20px;
        display: flex;
        justify-content: flex-end;

        > .save-btn,
        > .cancel-btn {
            position: relative;
            color: $sovis-white;
            font-size: 12px;
            text-align: center;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px;
            cursor: pointer;

            @include gradient-button();
        }

        > .cancel-btn {
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
}
</style>
